import { EditOutline24Icon } from "@vygruppen/spor-icon-react";
import { PanelAction } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/ActionsOverflowMenu";
import AddVehicle from "features/VehicleSidebar/VehicleList/AddVehicles/AddVehicle";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";

/**
 * "Rediger" action, available for both plan- and backup buses.
 */
export const useEditBackupVehicleAction = (
  vehicle: ReserveAlternativeTransport,
): PanelAction => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return {
    key: "edit",
    label: t("Rediger"),
    leftIcon: <EditOutline24Icon />,
    buttonVariant: "tertiary",
    buttonSize: "sm",
    buttonTitle: t("Rediger beredskapsbuss"),
    onSelect: () => setShowModal(true),
    modal: showModal ? (
      <AddVehicle
        editVehicle={vehicle}
        isReserveBusTabSelected={vehicle.serviceType === "RESERVE"}
        closeModal={() => setShowModal(false)}
      />
    ) : null,
  };
};
